export enum KnmKindCodesEnum {
  VK = 'VK',
  MZ = 'MZ',
  KZ = 'KZ',
  IV = 'IV',
  DP = 'DP',
  RO = 'RO',
  VP = 'VP',
}
